const cards = [
    [
        {
        id: 1,
        img: require('../images/blogs/blog_1.jpg'),
        category: "Research Problem",
        title: "معرفی روش علمی و اهمیت آن در تحقیقات علمی",
        text: "روش علمی یکی از ابزارهای کلیدی است که دانشمندان برای کشف قوانین به کار می‌گیرند...",
        authorImg: "../images/avatars/moein.jpeg",
        author: "مهندس معین خزایی",
        },
        {
        id: 2,
        img: require('../images/blogs/blog_2.jpg'),
        category: "Research Problem",
        title: "بیان مسئله و گزاره‌های تحقیق: اولین گام‌ها در پژوهش علمی",
        text: "انتخاب موضوع تحقیق اولین مرحله و یکی از مهم‌ترین بخش‌های یک پروژه پژوهشی است...",
        authorImg: "../images/avatars/amir.jpeg",
        author: "مهندس امیر ملکی",
        },
        {
        id: 3,
        img: require('../images/blogs/p2.jpg'),
        category: "Hypothesis",
        title: "مقدمه‌ای بر فرضیه در پژوهش علمی",
        text: "فرضیه در پژوهش علمی یک حدس آگاهانه است که رابطه بین دو یا چند متغیر را بیان می‌کند...",
        authorImg: "../images/avatars/amir.jpeg",
        author: "مهندس امیر ملکی",
        },
    ],
    [
        {
        id: 4,
        img: require('../images/blogs/p1.jpg'),
        category: "Research Constructs",
        title: "سازه، مفهوم و متغیر در پژوهش: تعاریف و انواع",
        text: "یکی از گام‌های کلیدی در تدوین پژوهش علمی، درک و تعریف مفاهیم، سازه‌ها و متغیرهاست...",
        authorImg: "../images/avatars/moein.jpeg",
        author: "مهندس معین خزایی",
        },
        {
        id: 5,
        img: require('../images/blogs/p3.jpg'),
        category: "Literature Review",
        title: "بررسی پیشینه تحقیق – رویکردها، اشتباهات رایج و چالش‌های جدید",
        text: "بررسی پیشینه تحقیق یکی از گام‌های ضروری و حیاتی در فرایند تحقیق علمی است...",
        authorImg: "../images/avatars/moein.jpeg",
        author: "مهندس معین خزایی",
        },
        {
        id: 6,
        category: "Data Collection",
        img: require('../images/blogs/blog_13_3.jpg'),

        title: "گردآوری داده‌ها: روش‌ها، پارادایم‌ها و تقسیم‌بندی‌ها",
        text: "گردآوری داده‌ها یکی از مراحل مهم در فرایند تحقیق به شمار می‌آید...",
        authorImg: "../images/avatars/moein.jpeg",
        author: "مهندس معین خزایی",
        },
    ],
    [
        {
        id: 7,
        img:require('../images/blogs/blog_7.jpg'),
        category: "Research Types",
        title: "دسته‌بندی تحقیقات بر حسب نحوه گردآوری داده‌ها: توصیفی و آزمایشی",
        text: "در پژوهش‌های علوم رفتاری، تحقیقات به دو دسته توصیفی و آزمایشی تقسیم می‌شوند...",
        authorImg: "../images/avatars/moein.jpeg",
        author: "مهندس معین خزایی",
        },
        {
        id: 8,
        img: require('../images/blogs/blog_4.jpg'),
        category: "Research Methods",
        title: "بررسی سایر روش‌های تحقیق: تاریخی، فلسفی و قوم‌نگاری",
        text: "روش‌های تحقیق مانند تاریخی، فلسفی و قوم‌نگاری رویکردهای خاصی را برای بررسی پدیده‌ها به کار می‌گیرند...",
        authorImg: "../images/avatars/moein.jpeg",
        author: "مهندس معین خزایی",
        },
        {
        id: 9,
        img: require('../images/blogs/blog_5.jpg'),
        category: "Research Ethics",
        title: "راهنمای کشوری اخلاق در انتشار آثار پژوهشی",
        text: "انتشار یافته‌های علمی نقش کلیدی در پیشرفت دانش و رعایت اصول اخلاقی دارد...",
        authorImg: "../images/avatars/moein.jpeg",
        author: "مهندس معین خزایی",
        },
    ],
    [        
        {
        id: 10,
        img: require('../images/blogs/blog_12.jpg'),
        category: "Research Ethics",
        title: "راهنمای کشوری اخلاق در انتشار آثار پژوهشی",
        text: "انتشار یافته‌های علمی نقش کلیدی در پیشرفت دانش و رعایت اصول اخلاقی دارد...",
        authorImg: "../images/avatars/amir.jpeg",
        author: "مهندس امیر ملکی",
        },
    ],
];

export default cards;